import React, {useRef} from "react";
import { useState } from "react";
import {
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  //FormText,
} from "reactstrap";
import UploadImg from "./UploadImg";

export default function ZaEditResponse({itemData, wishesID, wishesGID, setTriger, setDisplayEditResponses, clickedItemData, setClickedItemData, handleEditResponseBtn, keyforOffer, setItemsList, itemsList }) {
    const [desc, setDesc] = useState(itemData ? itemData.description : '')
    const [displayOfOffer, setDisplayOfOffer] = useState(true)
    console.log(clickedItemData)
    console.log('ITEMLIST:  ', itemsList)
    const [test, setTest] = useState(true)
    console.log(itemData)
  const form = useRef(null)
  const submitHandler = async (e) => {
    e.preventDefault();
    //console.log(event)
    //const form = document.getElementById('responseForm');
    const formData = new FormData(form.current);
    console.log(formData)
    console.log(Object.fromEntries(formData))
    const dataForPost = Object.fromEntries(formData);
    console.log(dataForPost)
    try {
      const response = await fetch(`api/v1/WatchHunter/wishes/${wishesID}/wish/${wishesGID}/offer/${itemData.gid}`, {
        method: "PUT",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          description: dataForPost.OfferDescription,
          Digits: dataForPost.digit,
          PriceSale: dataForPost.price,
          PriceMinimum: dataForPost.minPrice,
      }),
      });
      if (response.ok) {
        console.log(response);
        const payload = await response.json();
        console.log('PayLOAAAAAAAAAAAAAD', payload)
        //let newClickedItemData = [...clickedItemData]
        //setClickedItemData(newClickedItemData)
        setTriger(prevState => !prevState)
        //let newitemsList = [...itemsList]
        var currentToCompare = itemsList.slice();
        //currentToCompare.push({});
        setItemsList(currentToCompare);
        //console.log('newitemsListnewitemsList: ',newitemsList)
        setItemsList([...itemsList])
        //form.current.reset();
        //setDisplayEditResponses(false)
        //setTest(prevState => !prevState)
        setDesc(dataForPost.OfferDescription)
        console.log(desc)
        //const forceUpdate = useForceUpdate();
      }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (err) {
      console.error(err);
      // Handle errors here
    } finally {
      console.log("FINALLY");
      setDisplayEditResponses(true)
    }
  }
  const handleDeletOffer = async () => {
    console.log(wishesID, ', ', wishesGID, ', ', itemData.gid)
    try {
      const response = await fetch(`api/v1/WatchHunter/wishes/${wishesID}/wish/${wishesGID}/offer/${itemData.gid}`, {
        method: "DELETE",
      });
      if (response.ok) {
        console.log('OKRES', response);
        delete clickedItemData.offers[keyforOffer]
        setTriger(prevState => !prevState)
        //setDisplayEditResponses(false)
        //setTest(prevState => !prevState)
        //console.log('newClickedItemData2 newClickedItemData2 newClickedItemData2 : ',newClickedItemData2)
        //console.log('newClickedItemData:    ',newClickedItemData)
        /////setClickedItemData(newClickedItemData)
        //setDisplayOfOffer(false)
        //handleEditResponseBtn(clickedItemData)
      }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (err) {
      console.error(err);
      // Handle errors here
    } finally {
      console.log("FINALLY");
      setDisplayEditResponses(true)

    }
  }

  //create your forceUpdate hook
function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // An function that increment 👆🏻 the previous state like here 
    // is better than directly setting `value + 1`
}
  return (
    <div
      style={displayOfOffer ? {} : { display: "none !important" }}
      className="container wishResponses pb-5 editResponse"
    >
      <div className="d-flex justify-content-between align-items-baseline mt-2">
        <h3 className="mb-3">{/*itemsList[10].offers[0].description*/}{desc}</h3>
        <Button
          outline
          type="button"
          color="danger"
          onClick={() => { handleDeletOffer() }}
        >
          Delete
        </Button>
      </div>

      <div>
        <form 
        //id="responseForm" 
        ref={form} onSubmit={submitHandler}
        >
          <FormGroup row>
            <Label for="exampleOfferDescription" sm={2}>
              Offer Description
            </Label>
            <Col sm={10}>
              <Input
                defaultValue={desc || ''}
                type="textarea"
                name="OfferDescription"
                id="exampleOfferDescription"
                placeholder="Descrption of offer placeholder"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="exampleOfferExtraDescription" sm={2}>
              Offer details link
            </Label>
            <Col sm={10}>
              <Input
                type="url"
                name="OfferExtraDescription"
                id="exampleOfferExtraDescription"
                placeholder="If there is a url for the offer, write it here"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="digit" sm={2}>
              Digit
            </Label>
            <Col sm={10}>
              <Input
                defaultValue={itemData.digits || ''}
                type="text"
                name="digit"
                id="digit"
                placeholder="digit"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="price" sm={2}>
              Price{" "}
            </Label>
            <Col sm={10}>
              <Input
                defaultValue={itemData.priceSale || ''}
                type="number"
                name="price"
                id="examplePrice"
                placeholder="Sale Price"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="minPrice" sm={2}>
              Min Price
            </Label>
            <Col sm={10}>
              <Input
                defaultValue={itemData.priceMinimum || ''}
                type="number"
                name="minPrice"
                id="exampleMinPrice"
                placeholder="Min Pricw"
              />
            </Col>
          </FormGroup>
          <FormGroup row className="d-none">
            <Label for="exampleText" sm={2}>
              Text Area
            </Label>
            <Col sm={10}>
              <Input type="textarea" name="text" id="exampleText" />
            </Col>
          </FormGroup>
          <FormGroup tag="fieldset" row>
            <legend className="col-form-label col-sm-2">Item contains: </legend>
            <Col sm={10}>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch'/> Watch only
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch + Box'/> Watch + Box
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch + Paper'/> Watch + Paper
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch + Paper + Box'/> Watch + Paper + Box
                </Label>
              </FormGroup>
            </Col>
          </FormGroup>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <UploadImg />
            <UploadImg />
            <UploadImg />
          </div>
          <FormGroup check row>
            <Col sm={{ size: 12, offset: 0 }}>
              <Button>Update</Button>
            </Col>
          </FormGroup>
        </form>
      </div>
    </div>
  );
}
